import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ShieldCheck, Star, Mail, Clock } from 'lucide-react';
import { Card } from './ui/Card';
export function CheckoutSection() {
  const basicCheckoutUrl = 'https://www.profepack.com/cart/48076302418176:1';
  const proCheckoutUrl = 'https://www.profepack.com/cart/48077091635456:1';
  return <section className="py-8 md:py-28 bg-gray-50" id="comprar" data-id="element-36">
      <div className="container mx-auto px-4" data-id="element-37">
        <div className="max-w-7xl mx-auto" data-id="element-38">
          {/* Section Header */}
          <div className="text-center mb-4 md:mb-16" data-id="element-39">
            <h2 className="text-2xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 mb-2 md:mb-5" data-id="element-40">
              Elegí tu Pack
            </h2>
            <p className="text-sm md:text-xl text-gray-600 max-w-2xl mx-auto mb-2" data-id="element-41">
              Acceso inmediato a todos los recursos
            </p>
            <p className="text-xs md:text-base text-pink-600 font-semibold flex items-center justify-center gap-2 mb-2" data-id="element-42">
              <Mail className="w-4 h-4 md:w-5 md:h-5" data-id="element-43" />
              Entrega inmediata en formato PDF por correo electrónico
            </p>
            <p className="text-xs md:text-sm text-orange-600 font-medium flex items-center justify-center gap-1.5" data-id="element-44">
              <Clock className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-45" />
              Precio especial válido solo por hoy
            </p>
          </div>

          {/* Two Options Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 lg:gap-10" data-id="element-46">
            {/* LEFT BOX - Basic Option */}
            <Card className="overflow-hidden shadow-xl border-0 ring-1 ring-gray-200 flex flex-col" data-id="element-47">
              <div className="p-4 md:p-8 lg:p-10 flex flex-col flex-1" data-id="element-48">
                <div className="mb-3 md:mb-6" data-id="element-49">
                  <div className="flex items-center gap-1.5 mb-2 md:mb-4" data-id="element-50">
                    <span className="bg-pink-100 text-pink-700 px-2 py-1 md:px-3 md:py-1 rounded-full text-[9px] md:text-xs font-bold uppercase tracking-wide" data-id="element-51">
                      Oferta Limitada
                    </span>
                  </div>

                  <h3 className="text-lg md:text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-1 md:mb-3 leading-tight" data-id="element-52">
                    MegaPack Danza Lista
                  </h3>
                  <p className="text-xs md:text-lg text-gray-500 mb-2.5 md:mb-6" data-id="element-53">
                    Todo lo que necesitás para dar clases increíbles
                  </p>

                  <div className="flex items-end gap-2 mb-2.5 md:mb-7" data-id="element-54">
                    <div className="flex flex-col" data-id="element-55">
                      <span className="text-xs md:text-xl text-gray-400 line-through font-medium" data-id="element-56">
                        $47.900
                      </span>
                      <span className="text-3xl md:text-6xl font-bold text-gray-900 tracking-tight leading-none" data-id="element-57">
                        $19.990
                      </span>
                    </div>
                    <span className="mb-1 bg-green-100 text-green-700 px-2 py-1 md:px-3 md:py-1.5 rounded text-xs md:text-base font-bold" data-id="element-58">
                      -58%
                    </span>
                  </div>

                  <a href={basicCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-59">
                    <Button size="lg" variant="primary" className="w-full text-sm md:text-xl py-3 md:py-7 shadow-pink-200 hover:shadow-pink-300 transform transition-all hover:-translate-y-1" data-id="element-60">
                      Sí, quiero esta oferta
                    </Button>
                  </a>

                  <p className="text-center text-[9px] md:text-sm text-gray-400 mt-2 md:mt-4 flex items-center justify-center gap-1" data-id="element-61">
                    <ShieldCheck className="w-2.5 h-2.5 md:w-4 md:h-4" data-id="element-62" />
                    Pago seguro con Mercado Pago
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-2.5 md:pt-6 mt-auto" data-id="element-63">
                  <h4 className="text-xs md:text-base font-bold text-gray-900 mb-2 md:mb-4 uppercase tracking-wide" data-id="element-64">
                    Incluye:
                  </h4>
                  <ul className="space-y-1 md:space-y-2.5" data-id="element-65">
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-600" data-id="element-66">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-67" />
                      <span className="leading-tight" data-id="element-68">
                        6 Tomos Digitales Completos (3 a 18+ años)
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-600" data-id="element-69">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-70" />
                      <span className="leading-tight" data-id="element-71">
                        Kit Muestras Sin Pánico
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-600" data-id="element-72">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-73" />
                      <span className="leading-tight" data-id="element-74">
                        Generador de Aulas Llenas
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-600" data-id="element-75">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-76" />
                      <span className="leading-tight" data-id="element-77">
                        Biblioteca Musical BPM
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-600" data-id="element-78">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-79" />
                      <span className="leading-tight" data-id="element-80">
                        Actualizaciones de por vida
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>

            {/* RIGHT BOX - PRO Option - HIGHLIGHTED */}
            <Card className="overflow-hidden shadow-2xl border-2 border-gray-900 ring-2 ring-gray-900/30 flex flex-col relative" data-id="element-81">
              {/* "Mejor Valor" Badge */}
              <div className="absolute top-0 right-0 bg-gray-900 text-white text-[9px] md:text-sm font-black px-5 md:px-10 py-1 md:py-2 rotate-45 translate-x-[25%] translate-y-[40%] shadow-lg z-20 uppercase tracking-wider" data-id="element-82">
                Mejor Valor ⭐
              </div>

              <div className="p-4 md:p-8 lg:p-10 flex flex-col flex-1 bg-gradient-to-b from-gray-50 to-white" data-id="element-83">
                <div className="mb-3 md:mb-6" data-id="element-84">
                  <div className="flex items-center gap-1.5 md:gap-2.5 mb-2 md:mb-4 flex-wrap" data-id="element-85">
                    <span className="bg-gray-900 text-white px-2 py-1 md:px-3 md:py-1 rounded-full text-[9px] md:text-xs font-bold uppercase tracking-wide" data-id="element-86">
                      Pack Docente de Élite
                    </span>
                    <div className="flex gap-0.5" data-id="element-87">
                      <Star className="w-2.5 h-2.5 md:w-4 md:h-4 text-pink-600 fill-pink-600" data-id="element-88" />
                      <Star className="w-2.5 h-2.5 md:w-4 md:h-4 text-pink-600 fill-pink-600" data-id="element-89" />
                      <Star className="w-2.5 h-2.5 md:w-4 md:h-4 text-pink-600 fill-pink-600" data-id="element-90" />
                      <Star className="w-2.5 h-2.5 md:w-4 md:h-4 text-pink-600 fill-pink-600" data-id="element-91" />
                      <Star className="w-2.5 h-2.5 md:w-4 md:h-4 text-pink-600 fill-pink-600" data-id="element-92" />
                    </div>
                  </div>

                  <h3 className="text-lg md:text-3xl lg:text-4xl font-serif font-bold text-gray-900 mb-1 md:mb-3 leading-tight" data-id="element-93">
                    MegaPack + Protocolo Inclusivo
                  </h3>
                  <p className="text-xs md:text-lg text-gray-600 mb-2.5 md:mb-6" data-id="element-94">
                    MegaPack completo + Protocolo de Danza Inclusiva (NEE)
                  </p>

                  <div className="flex items-end gap-2 mb-2.5 md:mb-7" data-id="element-95">
                    <div className="flex flex-col" data-id="element-96">
                      <span className="text-xs md:text-xl text-gray-400 line-through font-medium decoration-pink-500/60 decoration-2" data-id="element-97">
                        $69.990
                      </span>
                      <span className="text-3xl md:text-6xl font-bold text-gray-900 tracking-tight leading-none" data-id="element-98">
                        $27.990
                      </span>
                    </div>
                    <span className="mb-1 bg-green-500 text-white px-2 py-1 md:px-3 md:py-1.5 rounded text-xs md:text-base font-bold shadow-lg" data-id="element-99">
                      -57%
                    </span>
                  </div>

                  <a href={proCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full group relative" data-id="element-100">
                    <div className="absolute -inset-1 bg-gradient-to-r from-gray-900 to-gray-700 rounded-lg blur opacity-30 group-hover:opacity-60 transition duration-200" data-id="element-101"></div>
                    <Button size="lg" className="relative w-full text-sm md:text-xl py-3 md:py-7 bg-gradient-to-r from-gray-900 to-black hover:from-gray-800 hover:to-gray-900 text-white border-0 shadow-xl transform transition-all hover:-translate-y-1 font-bold" data-id="element-102">
                      Sí, quiero esta oferta
                    </Button>
                  </a>

                  <p className="text-center text-[9px] md:text-sm text-gray-400 mt-2 md:mt-4 flex items-center justify-center gap-1" data-id="element-103">
                    <ShieldCheck className="w-2.5 h-2.5 md:w-4 md:h-4" data-id="element-104" />
                    Pago seguro con Mercado Pago
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-2.5 md:pt-6 mt-auto" data-id="element-105">
                  <h4 className="text-xs md:text-base font-bold text-gray-900 mb-2 md:mb-4 uppercase tracking-wide" data-id="element-106">
                    Pack Básico MÁS:
                  </h4>
                  <ul className="space-y-1 md:space-y-2.5" data-id="element-107">
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-700" data-id="element-108">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mt-0.5" data-id="element-109" />
                      <span className="leading-tight" data-id="element-110">
                        Protocolo de Danza Inclusiva (NEE)
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-700" data-id="element-111">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mt-0.5" data-id="element-112" />
                      <span className="leading-tight" data-id="element-113">
                        Adaptaciones para TEA, TDAH y Motriz
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-700" data-id="element-114">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mt-0.5" data-id="element-115" />
                      <span className="leading-tight" data-id="element-116">
                        Modelos de informes para gabinetes
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-700" data-id="element-117">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mt-0.5" data-id="element-118" />
                      <span className="leading-tight" data-id="element-119">
                        Rúbricas de evaluación adaptada
                      </span>
                    </li>
                    <li className="flex items-start gap-1.5 md:gap-2.5 text-xs md:text-base text-gray-700" data-id="element-120">
                      <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mt-0.5" data-id="element-121" />
                      <span className="leading-tight" data-id="element-122">
                        Certificado Digital Docente
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Card>
          </div>

          {/* Trust Badge */}
          <div className="mt-4 md:mt-16 text-center" data-id="element-123">
            <p className="text-xs md:text-base text-gray-500 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-124">
              <span className="flex items-center gap-1 md:gap-1.5" data-id="element-125">
                <ShieldCheck className="w-3 h-3 md:w-6 md:h-6 text-green-500" data-id="element-126" />
                <span className="font-semibold" data-id="element-127">Garantía 7 días</span>
              </span>
              <span className="hidden md:inline" data-id="element-128">•</span>
              <span className="hidden md:inline" data-id="element-129">Acceso inmediato</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}